import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { SitesPaginatedRequestBody } from 'api/sites/types';

interface ActiveFiltersProps {
    appliedFilters: SitesPaginatedRequestBody;
    onClearFilter: (filterId: string) => void;
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({
    appliedFilters,
    onClearFilter
}) => {
    const activeFilters = Object.entries(appliedFilters)
        .filter(([, value]) => value !== null && value !== '')
        .map(([key, value]) => ({ key, value }));

    if (activeFilters.length === 0) {
        return null;
    }

    // Map filter keys to display names
    const getDisplayName = (key: string) => {
        const displayNameMap: { [key: string]: string } = {
            customerSiteId: 'Customer Site ID',
            name: 'Site Name',
            type: 'Type',
            businessUnit: 'Business Unit',
            city: 'City',
            country: 'Country',
            scope2region: 'Region',
            status: 'Status',
            userName: 'Data Manager'
        };
        return displayNameMap[key] || key;
    };

    return (
        <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', background: '#F9FBFC', padding: '12px', borderRadius: '8px' }}>
            <Typography variant="body2" sx={{ mr: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                Active Filters:
            </Typography>
            {activeFilters.map(({ key, value }) => (
                <Chip
                    key={key}
                    label={`${getDisplayName(key)}: ${value}`}
                    onDelete={() => onClearFilter(key)}
                    deleteIcon={<Close />}
                    size="small"
                    variant="outlined"
                    sx={{
                        '& .MuiChip-deleteIcon': {
                            fontSize: '16px'
                        }
                    }}
                />
            ))}
        </Box>
    );
}; 